// Line-number gutter utilities for editor/output code panes.
// Example: syncLineNumberScroll(textarea, gutterPre).
import { getLineCount } from './format'

// Render one vertical sequence of line numbers for a text payload.
export function setLineNumbers(container: HTMLElement, content: string): void {
  const lineCount = getLineCount(content)
  const numbers: string[] = []
  // Build 1..N list so gutters always match visible content lines.
  for (let line = 1; line <= lineCount; line += 1) {
    numbers.push(String(line))
  }

  container.textContent = numbers.join('\n')
}

// Keep line number gutter scroll position aligned with text viewport.
export function syncLineNumberScroll(source: HTMLElement, gutter: HTMLElement): void {
  gutter.scrollTop = source.scrollTop
}
